import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/icons-img/arrow-download.svg'


const _withScopeId = n => (_pushScopeId("data-v-44af96dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-top" }
const _hoisted_3 = { class: "header--center" }
const _hoisted_4 = { class: "header--left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "header__title" }
const _hoisted_8 = { class: "header--right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-dots" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["href", "download"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "arrow-download",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  class: "header-bottom",
  style: {"min-height":"21px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "back-link white",
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-click-back')))
          }, _hoisted_6)
        ]),
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.isPublicPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShare && _ctx.onShare(...args))),
                class: _normalizeClass(["nav-btn", { disabled: !_ctx.toShare }])
              }, _hoisted_10, 2))
            : _createCommentVNode("", true),
          (!_ctx.isPublicPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-view-more'))),
                class: "nav-btn"
              }, _hoisted_12))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("a", {
                  href: _ctx.downloadUrl,
                  download: _ctx.file.name
                }, _hoisted_16, 8, _hoisted_14)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (!_ctx.isPublicCasesPage)
        ? (_openBlock(), _createBlock(_component_drive_shared_bar, {
            key: 0,
            onOnVisitChat: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-visit-chat')))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}